import axios from "axios";

const BASE_URL = "https://blood-backend-app-c4agebg6e3b4bxhn.centralindia-01.azurewebsites.net/api/donors";

class DonorService {

  getAllDonors() {
    return axios.get(BASE_URL);
  }

  getDonorsByBloodGroup(bloodGroup) {
    return axios.get(`${BASE_URL}/blood/${bloodGroup}`);
  }

  addDonor(donor) {
    return axios.post(BASE_URL, donor);
  }

  deleteDonor(id) {
    return axios.delete(`${BASE_URL}/${id}`);
  }

  updateDonor(id, donor) {
    return axios.put(`${BASE_URL}/${id}`, donor);
  }

}

const donorService = new DonorService();
export default donorService;
